const i = (e) => ["title", "src", "thumbnail", "selfHosted", "extension"].every((t) => t in e);
export {
  i as default
};
